import type React from 'react'
import type { IconProps } from './types'

/**
 * Loop Icon - Material Symbols "loop"
 * Used for Loops module
 */
const LoopIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M12 4V1L8 5L12 9V6C15.87 6 19 9.13 19 13C19 14.93 18.22 16.68 16.95 17.95L18.36 19.36C20.04 17.68 21 15.45 21 13C21 8.03 16.97 4 12 4ZM12 20C8.13 20 5 16.87 5 13C5 11.07 5.78 9.32 7.05 8.05L5.64 6.64C3.96 8.32 3 10.55 3 13C3 17.97 7.03 22 12 22V25L16 21L12 17V20Z' />
	</svg>
)

export default LoopIcon
